<template>
  <PageHeader :showBreadcrumb="true" />
  <form v-if="authStore.isAdminUser && appStore.entities.length > 0" @submit.stop.prevent="onSubmit">
    <div class="container">
      <DataTable v-model:filters="filters" :value="userEntities" ref="adminUserEntitiesTable" dataKey="userEntityId"
                 stripedRows :loading="loading" paginator :rows="25" sortField="lastUploadDate" :sortOrder="-1">
        <template #header>
          <div class="header-components gap-3">
            <IconField>
              <InputText v-model="filters['global'].value" label="Keyword Search" aria-label="Keyword Search" placeholder="Keyword Search" />
              <InputIcon>
                <i class="pi pi-search" ></i>
              </InputIcon>
            </IconField>
            <Button icon="pi pi-external-link" rounded label="Export" @click="exportCSV($event)" />
          </div>
        </template>
        <template #empty> No Data. </template>
        <Column field="entityName" header="Entity Name" :sortable="true"/>
        <Column field="email" header="Email" :sortable="true"/>
        <Column field="fullName" header="User Name" :sortable="true"/>
        <Column field="hasUploaded" header="Has Uploaded?" :sortable="true"/>
        <Column field="lastUploadDate" header="Last Uploaded" :sortable="true"/>
        <Column :exportable="false" header="Actions" style="width: 10%; min-width: 8rem" bodyStyle="text-align: center">
          <template #body="slotProps">
            <AdminUserActionButtons
              :user-id="slotProps.data.userId"
              :email="slotProps.data.email"
              :full-name="slotProps.data.fullName"
              :entity-name="slotProps.data.entityName"
              :user-entity-id="slotProps.data.userEntityId"
              :can-login="slotProps.data.canLogin"
              @modified="handleModified"/>
          </template>
        </Column>
      </DataTable>
    </div>
  </form>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import PageHeader from "@/components/common/PageHeader.vue";
import {useAppStore} from "@/stores/appStore.js";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from "primevue/button";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import {useAuthStore} from "@/stores/authStore.js";
import {getAdminUserEntities} from "@/services/adminService.js";
import {FilterMatchMode} from '@primevue/core/api';
import AdminUserActionButtons from "@/components/admin/AdminUserActionButtons.vue";

const appStore = useAppStore();
const authStore = useAuthStore();

const userEntities = ref([]);
const adminUserEntitiesTable = ref();
const loading = ref(true);

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const exportCSV = () => {
  adminUserEntitiesTable.value.exportCSV();
};

const getUserEntities = async () => {
  const entities = await getAdminUserEntities();
  entities.forEach((e) => {
    if (e.lastUploadDate) {
      e.lastUploadDate = new Date(e.lastUploadDate).toLocaleString();
    } else {
      e.lastUploadDate = '—';
    }
    e.hasUploaded = e.hasUploaded ? 'Y' : 'N';
  });
  userEntities.value = entities;
};

onMounted(() => {
  getUserEntities().then(() => {loading.value = false;});
});

const handleModified = async () => {
  await getUserEntities();
};
</script>

<style scoped>
.tx-p {
  padding: 1.5rem;
  height: 200px;
}

.header-components {
  display: flex;
  justify-content: flex-end;
}
</style>